export const VERIFY_FORMER_CUSTOMER_BEGIN = "VERIFY_FORMER_CUSTOMER_BEGIN";
export const VERIFY_FORMER_CUSTOMER_SUCCESS = "VERIFY_FORMER_CUSTOMER_SUCCESS";
export const VERIFY_FORMER_CUSTOMER_FAILURE = "VERIFY_FORMER_CUSTOMER_FAILURE";
export const DELETE_FORMER_PERSONAL_DATA_BEGIN = "DELETE_FORMER_PERSONAL_DATA_BEGIN";
export const DELETE_FORMER_PERSONAL_DATA_SUCCESS = "DELETE_FORMER_PERSONAL_DATA_SUCCESS";
export const DELETE_FORMER_PERSONAL_DATA_FAILURE = "DELETE_FORMER_PERSONAL_DATA_FAILURE";
export const FORMER_CUSTOMER_CREATE_UPDATE_PROFILE_BEGIN = "FORMER_CUSTOMER_CREATE_UPDATE_PROFILE_BEGIN";
export const FORMER_CUSTOMER_CREATE_UPDATE_PROFILE_SUCCESS = "FORMER_CUSTOMER_CREATE_UPDATE_PROFILE_SUCCESS";
export const FORMER_CUSTOMER_CREATE_UPDATE_PROFILE_FAILURE = "FORMER_CUSTOMER_CREATE_UPDATE_PROFILE_FAILURE";
export const PENDING_CASE_BEGIN = "PENDING_CASE_BEGIN";
export const PENDING_CASE_SUCCESS = "PENDING_CASE_SUCCESS";
export const PENDING_CASE_FAILURE = "PENDING_CASE_FAILURE";
export const FORMER_CUSTOMER_CREATE_CASE_BEGIN = "FORMER_CUSTOMER_CREATE_CASE_BEGIN";
export const FORMER_CUSTOMER_CREATE_CASE_SUCCESS = "FORMER_CUSTOMER_CREATE_CASE_SUCCESS";
export const FORMER_CUSTOMER_CREATE_CASE_FAILURE = "FORMER_CUSTOMER_CREATE_CASE_FAILURE";
export const FORMER_CUSTOMER_ADDRESS_DOB_BEGIN = "FORMER_CUSTOMER_ADDRESS_DOB_BEGIN";
export const FORMER_CUSTOMER_ADDRESS_DOB_SUCCESS = "FORMER_CUSTOMER_ADDRESS_DOB_SUCCESS";
export const FORMER_CUSTOMER_ADDRESS_DOB_FAILURE = "FORMER_CUSTOMER_ADDRESS_DOB_FAILURE";
export const CREATE_UUID_BEGIN = "CREATE_UUID_BEGIN";
export const CREATE_UUID_SUCCESS = "CREATE_UUID_SUCCESS";
export const CREATE_UUID_FAILURE = "CREATE_UUID_FAILURE";
export const CREATE_TIME_FRAME_BEGIN = "CREATE_TIME_FRAME_BEGIN";
export const CREATE_TIME_FRAME_SUCCESS = "CREATE_TIME_FRAME_SUCCESS";
export const CREATE_TIME_FRAME_FAILURE = "CREATE_TIME_FRAME_SUCCESS";
export const CREATE_FILE_FORMAT_BEGIN = "CREATE_FILE_FORMAT_BEGIN";
export const CREATE_FILE_FORMAT_SUCCESS = "CREATE_FILE_FORMAT_SUCCESS";
export const CREATE_FILE_FORMAT_FAILURE = "CREATE_FILE_FORMAT_FAILURE";
export const FORMER_DOC_VERIFICATION_BEGIN = "FORMER_DOC_VERIFICATION_BEGIN";
export const FORMER_DOC_VERIFICATION_SUCCESS = "FORMER_DOC_VERIFICATION_SUCCESS";
export const FORMER_DOC_VERIFICATION_FAILURE = "FORMER_DOC_VERIFICATION_FAILURE";
export const FORMER_VALIDATE_SECURE_PIN_BEGIN = "FORMER_VALIDATE_SECURE_PIN_BEGIN";
export const FORMER_VALIDATE_SECURE_PIN_SUCCESS = "FORMER_VALIDATE_SECURE_PIN_SUCCESS";
export const FORMER_VALIDATE_SECURE_PIN_FAILURE = "FORMER_VALIDATE_SECURE_PIN_FAILURE";
export const CLOSE_CASEID_BEGIN = "CLOSE_CASEID_BEGIN";
export const CLOSE_CASEID_SUCCESS = "CLOSE_CASEID_SUCCESS";
export const CLOSE_CASEID_FAILURE = "CLOSE_CASEID_FAILURE";
export const BREADCRUMBS_LINK_SUCCESS = "BREADCRUMBS_LINK_SUCCESS";
export const BREADCRUMBS_LINK_BEGIN = "BREADCRUMBS_LINK_BEGIN";
export const BREADCRUMBS_LINK_FAILURE = "BREADCRUMBS_LINK_FAILURE";